module["exports"] = [
  "######"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/zh_CN/address/postcode.js
 ** module id = 1181
 ** module chunks = 0
 **/